import { sendData,getData,getExcel } from './../../misc/server.js';

export default {
  state: {

    data:null,
    loading:false,
  
  },
  mutations: {
  
    setData(state,payload)
    {
      state.data=payload;
    },
    setLoading(state,payload)
    {
      state.loading=payload;
    }
   
  },
   actions: {
    
    generatePAReport({commit},data)
    {
        var url="/report";

        url+="?month="+data.month+"&year="+data.year;

        url+="&";
      
        commit("setLoading",true);
        getData(url,(response)=>{
            
          commit("setLoading",false);
            commit("setData",response);
             
        })
    },
    exportPAReport({commit},data)
    {
      var url="/report/export";
      url+="?month="+data.month+"&year="+data.year;
      url+="&";
     
      getExcel(url);
    }

  },
  getters: {
   
    pa_report(state)
    {
      return state.data;
    },
    pa_report_loading(state)
    {
      return state.loading;
    }
 
  }
}